/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Password = (function () {

    function Password () {

        Monet.UI.Fields.TextField.apply(this, arguments);

        this.createBaseStructure();

        this.render = function () {

            this.createElement();
            this.input.type = "password";
            this.input.autocomplete="new-password";
            return this.rootEl;

        };

    }

    return Password;

}());